var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38281 6.86973L12.0615 1.17825C12.7421 0.496084 13.8197 0.496084 14.5003 1.17825C15.1493 1.82873 15.1684 2.90322 14.543 3.5782C14.529 3.59326 14.5148 3.60806 14.5003 3.62258L9.00165 9.13362L6.38281 9.66663V6.86973Z",
    stroke: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9944 0.137347C10.8033 0.0491826 10.5906 -5.82461e-08 10.3665 -6.84813e-08L1.50011 -4.73267e-07C0.671687 -5.11088e-07 0.000114413 0.671573 0.000114378 1.5L0.000113918 12.5C0.000113883 13.3285 0.671687 14 1.50011 14L10.3665 14C11.1949 14 11.8665 13.3285 11.8665 12.5L11.8665 8.93967L10.8665 9.81557L10.8665 12.5C10.8665 12.7762 10.6426 13 10.3665 13L1.50011 13C1.22397 13 1.00011 12.7762 1.00011 12.5L1.00011 1.5C1.00011 1.22386 1.22397 1 1.50011 1L10.1326 1L10.9944 0.137347Z",
    fill: "#DD2207"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.9ac12e03.svg";
export { ForwardRef as ReactComponent };